import {
  IPreviewRestaurantsRequest,
  IPreviewRestaurantsResponse,
  IProvider,
  IRestaurantBySlugRequest,
  IRestaurantBySlugResponse,
  IRestaurantDistancePriceRequest,
  IRestaurantDistancePriceResponse,
  IRestaurantRequest,
  IRestaurantsByRatingRequest,
  IRestaurantsByRatingResponse,
  IRestaurantSearchRequest,
  IRestaurantSearchResponse,
} from 'types';

import {api} from '../setup';

const BASE_PATH = 'restaurants';

export const getRestaurants = (params: IRestaurantRequest): Promise<IProvider> => {
  return api.get(`/${BASE_PATH}`, {
    params,
  });
};

export const getRestaurantBySlug = (
  query: IRestaurantBySlugRequest,
  locale: string,
  coordinates: string,
): Promise<IRestaurantBySlugResponse> => {
  return api.get(`/${BASE_PATH}/${query.slug}`, {
    headers: {
      ['Accept-Language']: locale,
      ['Location-Coordinates']: coordinates,
    },
  });
};

export const getRestaurantSearch = (params: IRestaurantSearchRequest): Promise<IRestaurantSearchResponse[]> => {
  return api.get(`/${BASE_PATH}/search`, {params});
};

export const getRestaurantsByRatings = ({
  slug,
  limit,
  offset,
}: IRestaurantsByRatingRequest): Promise<IRestaurantsByRatingResponse> => {
  return api.get(`/${BASE_PATH}/${slug}/ratings`, {
    params: {limit, offset},
  });
};

export const getPreviewRestaurants = (
  query: IPreviewRestaurantsRequest,
  locale: string,
): Promise<IPreviewRestaurantsResponse> => {
  if (!query.slug) return Promise.reject('getPreviewRestaurants - slug cannot be undefined');
  return api.get(`provider-preview/${query.slug}`, {
    headers: {['Accept-Language']: locale},
  });
};

export const getRestaurantDistancePrice = (
  slug: string | undefined,
  coords: IRestaurantDistancePriceRequest,
): Promise<IRestaurantDistancePriceResponse> => {
  if (!slug) return Promise.reject('getRestaurantDistancePrice - slug cannot be undefined');
  return api.post(`${BASE_PATH}/${slug}/get-distance-price`, coords);
};
